import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FacebookIcon from './FacebookIcon';
// import GitHubIcon from './GitHubIcon';
import InstagramIcon from './InstagramIcon';
import TwitterIcon from './TwitterIcon';
export default function SocialIcons() {
    return (_jsxs("ul", { className: "flex space-x-6", children: [_jsx(TwitterIcon, {}), _jsx(FacebookIcon, {}), _jsx(InstagramIcon, {})] }));
}
